<template>
<div class="chapter">
<div class="inner_page">
<div class="title">
<p class="title">T<span class="small2">HE</span> C<span class="small2">OMANCHE</span><br/>E<span class="small2">MPIRE</span></p>
<p class="center"><img alt="" src="OEBPS/images/line.jpg"/></p>
<p class="author">Pekka Hämäläinen</p>
<p class="pub"><i>Published in Association with The William P. Clements Center for<br/>Southwest Studies, Southern Methodist University</i><br/><br/>
<i>Yale University Press<br/>New Haven &amp; London</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?522ec43c